import { render } from "./PlatformList.vue?vue&type=template&id=316df2b1&scoped=true"
import script from "./PlatformList.vue?vue&type=script&lang=js"
export * from "./PlatformList.vue?vue&type=script&lang=js"

import "./PlatformList.vue?vue&type=style&index=0&id=316df2b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316df2b1"]])

export default __exports__